<script>
    export let messages;
    export let conversation;
</script>

<section>
    <div id="chatContainer">
        <div id="chat">
            {#if messages}
                {#each [...messages] as [key,value]}
                    <div class="message" id={key}>
                        <div class="bubble" class:mine="{value.from === conversation.me.id}">
                            {value.body.message}
                        </div>
                        <div class="author" class:mine="{value.from === conversation.me.id}">
                            <!-- {value._embedded.from_user.display_name} -->
                            { value.body.displayName ? value.body.displayName : "N/A" }
                        </div>
                    </div>
                {/each}
            {/if}
        </div>
    </div>
</section>

<style>
    section {
        max-width: 300px;
        width: 100%;
        height: 50vh;
    }

    #messagesContainer {
        height: 100%;
        overflow-y: auto;
        /* display: flex;
        flex-direction: column-reverse; */
        /* flex-direction: column; */
        /* justify-content: flex-end; */
    }

    #chatContainer {
        height: 100%;
        overflow-y: auto;
        display: flex;
        flex-direction: column-reverse;
    }

    .bubble {
        margin: 10px 0 0;
        background: lightgray;
        border-radius: 10px 10px 10px 0;
        padding: 10px;
        width: auto;
    }
    .bubble.mine {
        border-radius: 10px 10px 0 10px;
    }
    .author {
        text-align: left;
    }

    .author.mine{
        text-align: right;
    }

</style>